import styled from 'styled-components'

import { useTheme } from '@/lib/hooks'

// Plus sign with a sage leaf sprouting between the arms
const BrandMark = ({ size, accent }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <rect x="13" y="7" width="6" height="18" rx="3" fill="currentColor" />
    <rect x="7" y="13" width="18" height="6" rx="3" fill="currentColor" />
    <path d="M20.5 11.5C20.5 7.6 23.1 5 27 5c0 3.9-2.6 6.5-6.5 6.5z" fill={accent} />
  </svg>
)

const BrandLogo = ({ size = 36 }) => {
  const themes = useTheme()

  if (!themes.brand) {
    return <img src={themes.assets.logo} alt="logo" />
  }

  return (
    <Wordmark $size={size} aria-label={`${themes.brand.name} ${themes.brand.tagline}`}>
      <BrandMark size={size} accent={themes.colors.accent} />
      <span className="name">{themes.brand.name}</span>
      <span className="tagline">{themes.brand.tagline}</span>
    </Wordmark>
  )
}

export default BrandLogo

const Wordmark = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $size }) => $size * 0.22}px;
  color: #ffffff;
  font-family: ${({ theme }) => theme.font};
  line-height: 1;

  .name {
    font-size: ${({ $size }) => $size * 0.78}px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .tagline {
    align-self: flex-end;
    margin-bottom: ${({ $size }) => $size * 0.16}px;
    font-size: ${({ $size }) => $size * 0.3}px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.accent};
  }
`
